module.exports = __webpack_public_path__ + "img/Reset-Aria_back.75d9ff13.png";